import { render } from "./BaseCertificatesImport.vue?vue&type=template&id=64dedb46"
import script from "./BaseCertificatesImport.vue?vue&type=script&lang=js"
export * from "./BaseCertificatesImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__